const FRIENDLY_TYPE_MAP: Record<string, string> = {
  image: "image/*",
  video: "video/*",
  pdf: "application/pdf",
  "image/jpg": "image/jpeg",
};

export const normalizeValidFileTypes = (types: string): string => {
  const parts = types
    .split(",")
    .map((t) => t.trim())
    .filter(Boolean);
  const normalized = parts.map((part) => FRIENDLY_TYPE_MAP[part.toLowerCase()] ?? part.toLowerCase());

  const wildcardBases = new Set(normalized.filter((t) => t.endsWith("/*")).map((t) => t.slice(0, -2)));

  const filtered = normalized.filter((t) => {
    if (t.endsWith("/*")) return true;
    const base = t.split("/")[0];
    return !base || !wildcardBases.has(base);
  });

  return [...new Set(filtered)].join(",");
};
